import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { EvaluationComponent } from './evaluation.component';
import { ImageCanvasViewerComponent } from './image-canvas-viewer/image-canvas-viewer.component';
import { LegendComponent } from './legend/legend.component';
import { SideContainerComponent } from './side-container/side-container.component';
import { VideoPlayerComponent } from './video-player/video-player.component';

@NgModule({
    declarations: [
        EvaluationComponent,
        LegendComponent,
        VideoPlayerComponent,
        SideContainerComponent,
        ImageCanvasViewerComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        FormsModule,
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        SharedModule,
        MatSlideToggleModule,
        MatIconModule,
    ],
    exports: [
        EvaluationComponent,
        LegendComponent,
        VideoPlayerComponent,
        SideContainerComponent,
    ],
    providers: [],
})
export class EvaluationModule {}

export { EvaluationComponent };
